export default function getHeaderElementClass(isCreateAccountActive) {
  return {
    header: isCreateAccountActive
      ? 'dtv-html5-c-pin-login-flow-create-account__header'
      : '',
    h1: isCreateAccountActive
      ? 'dtv-html5-c-pin-login-flow-create-account__page-title'
      : 'dtv-html5-c-pin-login__page-title',
  };
}
